<template>
  <el-drawer
    title="子母单标识"
    :visible.sync="drawer"
    direction="rtl"
    :before-close="handleClose"
    size="40%"
  >
    <div class="zim_content">
      <div class="active_bar">
        <el-button type="primary" @click="handleCreate">
          新 增
        </el-button>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        highlight-current-row
      >
        <el-table-column
          v-for="item in multiPiecesColumn"
          :key="item.prop"
          :prop="item.prop"
          :label="item.label"
          v-bind="item"
        >
          <template #default="scope">
            <template v-if="item.prop === 'markStatus'">
              <span :style="`color:${statusStyleColor[scope.row[item.prop]]}`">{{ markStatusMap[scope.row[item.prop]] }}</span>
            </template>
            <template v-else-if="item.prop === 'action'">
              <el-button type="text" @click="handleDelete(scope.row)">
                删除
              </el-button>
            </template>
            <span v-else v-text="item.formatter ? item.formatter(scope.row) : scope.row[item.prop]" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="drawer__footer">
      <el-button @click="handleClose">
        取 消
      </el-button>
    </div>
    <multiPiecesEdit ref="multiPiecesEdit" @refresh="handleRefresh" />
  </el-drawer>
</template>

<script>
import { parentMarkList, parentMarkDelete } from '@/views/shipperSeviceSetting/serveConfig/api';
import { multiPiecesColumn, markStatus, markStatusMap } from './const';
import multiPiecesEdit from './multiPiecesEdit.vue';

const statusStyleColor = {
  ENABLE: '#059E84',
  RECONCILED: '#909399',
  DELETED: '#F53F3F',
};
export default {
  name: 'MultiPiecesconfig',
  components: {
    multiPiecesEdit,
  },
  data() {
    return {
      statusStyleColor,
      markStatus,
      markStatusMap,
      loading: false,
      multiPiecesColumn,
      tableData: [],
      drawer: false,
      customersDetail: {},
    };
  },
  methods: {
    async show(customersDetail) {
      this.customersDetail = customersDetail;
      await this.fetchData();
      this.drawer = true;
    },
    async fetchData() {
      this.loading = true;
      const { ownerTenantId, customerCode } = this.customersDetail || {};
      try {
        const res = await parentMarkList({
          customerCode,
          tenantId: ownerTenantId,
          statuses: [markStatus.ENABLE, markStatus.RECONCILED],
        });
        this.tableData = res || [];
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    handleRefresh() {
      this.fetchData();
    },
    handleClose() {
      this.$emit('refreshMarkTotal');
      this.drawer = false;
    },
    handleCreate() {
      this.$refs.multiPiecesEdit.show(this.customersDetail);
    },
    handleDelete(row) {
      this.$confirm('确定删除此标识?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        await parentMarkDelete({ id: row.id });
        this.$message.success('删除成功');
        this.handleRefresh();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.active_bar{
  margin-bottom: 24px;
}
.zim_content{
  margin-bottom:64px;
}
.drawer__footer{
  height: 64px;
  width: calc(100% - 24px);
  border-top: 1px solid #EBEEF5;
  line-height: 64px;
  padding-right: 24px;
  text-align: right;
  position: absolute;
   background: #fff;
  bottom: 0;
  z-index: 100;
}
</style>
